<!-- <div style="height:80px; width:100%;"> I am header </div>  -->
 
<!--  AI Search page starts -->

<div class="ai-search-page height-100 header_section">

    <button (click)="goBack()" class="ai-search-back-btn"><img src="branding/theme/assets/static_assets/ic-left-arrow-on-lbg.svg">Back</button>

    <div class="ai-search-container">
       <div class="top-container" #scrollContainer>
            <div class="ai-search-header-section">
                <div class="search-greeting">
                    <span class="ai-btn-round">
                        <div class="ai-grad"></div>
                        <img src="branding/theme/assets/static_assets/ic-ai-collapsed.svg">
                    </span>
                    <span>
                        Hey 
                        @if(this.guest){
                            <span>
                                there
                            </span>
                        }@else {
                            @if(enableProfiles){
                                <span>{{profileInfo.name}}</span>
                            }@else {
                                <span>
                                    {{userName}}
                                </span>
                            }
                        }
                    </span>
                </div>
                <div class="recommendation-container">
                    <div class="labeltxt">Here are some recommendations from us:</div>
                    <div class="search-tags-container">
                        @if(this.aiChatDefaultDatas.length > 0){
                            @for(data of aiChatDefaultDatas; track data){
                                <button [disabled]="showLoader" (click)="sendData(data)" class="btn search-tag">{{data}}</button>
                            }
                        }
                    </div>
                </div>
            </div>

            <div class="ai-search-output-container">
                <div style="width: 100%;">
                    @for(chat of chatArray; track chat){
                        <div>
                            @if(chat.request){
                                <div class="message-sender-container">
                                    <div class="chat-container">
                                        <div class="icon-container">
                                            @if(guest){
                                                <img class="non-profile-pic" src="branding/theme/assets/static_assets/ic-user.svg">
                                            }
                                            @else {
                                                @if(!enableProfiles){
                                                    <img class="non-profile-pic" src="branding/theme/assets/static_assets/ic-user.svg">
                                                  }@else {
                                                    @if (profileInfo?.icon) {
                                                      <img class="non-profile-pic" src="{{imagePath + profileInfo?.icon}}">
                                                    }@else{
                                                      <div class="non-profile-pic"> {{((profileInfo.name).charAt(0)).toUpperCase()}} </div>
                                                    }
                                                  }
                                            }
                                        </div>
                                        <div class="message-display">{{chat.request}}</div>
                                    </div>
                                </div>
                            }
                            @if(chat.response){
                                <div class="message-received-container">
                                    <div class="chat-container">
                                        <div class="icon-container"><img src="branding/theme/assets/static_assets/ic-ai-collapsed.svg"></div>
                                        <div class="message-display">
                                            <span class="no-data-resp">{{chat.message}}</span>
                                            @if(chat.response.length > 0){
                                                <!-- list content start -->
                                                @for(content of chat.response; track content){
                                                    <div class="list-container">
                                                        <div class="list-item bg-cards1">
                                                            <div  class="card-grad"><img  class="card-img" [src]="settingsService.getImage(content.poster_landscape,'card')" ></div>
                                                            
                                                            <div  class="details">
                                                                <div  class="head">
                                                                <div  class="title text-hidden">{{content?.title}}</div>
                                                                <div  class="duration">
                                                                    <div  class="time">{{transform(content?.duration_min)}}</div>
                                                                    <img  class="clock" src="branding/theme/assets/static_assets/ic-time-on-lbg.svg"></div>
                                                                </div>
                                                                <div  class="description text-vertical-hidden"> {{content?.description}} </div>
                                                                <div class="details-btn-container">
                                                                    <button class="btn search-tag" (click) ="contentRoute(content)">More Info</button>
                                                                    @if (content.has_trailer && enableTrailer && (content.trailers?.length > 0) ) {
                                                                        <button class="btn search-tag" (click)="playContentService.playTrailer(content)"><span>&#9654; </span>Trial</button>
                                                                    }
                                                                    <!-- <span  class="action-card-tooltip">
                                                                        <img src="branding/theme/assets/static_assets/ic-empty-heart-on-lbg.svg" class="cursor-pointer banner-btn">
                                                                        <span  class="action-card-tooltip-text">Add to wishlist</span>
                                                                    </span>  -->
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                <!-- list content end -->
                                            }
                                            <!-- @else {
                                                <span class="no-data-resp">
                                                    I couldn’t find any matching results for you! Let’s try something else?
                                                </span>
                                            } -->
                                        </div>
                                    </div>
                                </div>
                            }

                        </div>                     
                    }
                    @if(showLoader){
                        <div class="message-received-container">
                            <div class="chat-container">
                                <div class="icon-container"><img class="loader" src="branding/theme/assets/static_assets/ic-app-loader.svg"></div>
                            </div>
                        </div>
                    }
                    @if(!showLoader && chatArray.length > 1 && chatArray[chatArray.length-1].response.length > 0){
                        <div class="show-more-container"><button class="btn search-tag" (click)="sendData('show more')" >Show more</button></div>
                    }
                </div>

            </div>
        </div> 
    </div>


    <form [formGroup]="chatForm">
        <div class="ai-search-input-container">
                <div class="chat-input-container">
                    <div class="chat-icon-container">
                        <img src="branding/theme/assets/static_assets/ic-ai-chat-box.svg">
                    </div>
                    <textarea [readOnly]="showLoader" placeholder="Send message" formControlName="userMessage" (keydown.enter)="onEnter($event)" required class="resize-none"></textarea>
                </div>
                <div class="ai-search-arrow" (click)="sendMessage()"><img src="branding/theme/assets/static_assets/ic-ai-right-filled-enter-arrow.svg"></div>
        </div>
    </form>

</div>

<!-- AI Search page ends -->